import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Construction, LogIn } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const MaintenancePage = () => {
  const [message, setMessage] = useState('We are currently working on something amazing. Check back soon!');

  useEffect(() => {
    fetchMessage();
  }, []);

  const fetchMessage = async () => {
    try {
      const response = await axios.get(`${API}/settings/maintenance`);
      if (response.data.message) {
        setMessage(response.data.message);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleLogin = () => {
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505] px-6" data-testid="maintenance-page">
      <div className="text-center max-w-lg">
        <div className="w-24 h-24 rounded-full bg-[#D4AF37]/20 flex items-center justify-center mx-auto mb-8">
          <Construction size={48} className="text-[#D4AF37]" />
        </div>
        
        <div className="mb-6">
          <span className="brand-font text-5xl text-[#D4AF37]">23</span>
          <span className="brand-font text-4xl text-[#D4AF37]">madethis</span>
        </div>
        
        <h1 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Syne' }}>
          Under Maintenance
        </h1>
        
        <p className="text-neutral-400 text-lg mb-8">
          {message}
        </p>
        
        <div className="flex justify-center gap-2 mb-8">
          <div className="w-2 h-2 rounded-full bg-[#D4AF37] animate-pulse" style={{ animationDelay: '0ms' }} />
          <div className="w-2 h-2 rounded-full bg-[#D4AF37] animate-pulse" style={{ animationDelay: '200ms' }} />
          <div className="w-2 h-2 rounded-full bg-[#D4AF37] animate-pulse" style={{ animationDelay: '400ms' }} />
        </div>

        {/* Admin Login Button */}
        <button 
          onClick={handleLogin}
          className="inline-flex items-center gap-2 px-6 py-3 bg-transparent border border-[#D4AF37]/30 text-[#D4AF37] rounded-xl hover:bg-[#D4AF37]/10 transition-all text-sm"
          data-testid="maintenance-login-btn"
        >
          <LogIn size={16} />
          Admin Login
        </button>
      </div>
    </div>
  );
};

export default MaintenancePage;
